import { render } from "./aging-report-customer.vue?vue&type=template&id=64a6c52a"
import script from "./aging-report-customer.vue?vue&type=script&lang=js"
export * from "./aging-report-customer.vue?vue&type=script&lang=js"

import "./aging-report-customer.vue?vue&type=style&index=0&id=64a6c52a&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__